import React, { useState, useEffect } from 'react';
import { API_BASED_URL } from '../config.js';

const SuperuserRegistration = ({ onClose, onSuccess }) => {
  const [facilities, setFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    console.log('SuperuserRegistration mounted, token:', token);
    console.log('Token from localStorage:', localStorage.getItem('authToken'));
    fetchFacilities();
  }, []);

  const fetchFacilities = async () => {
    try {
      const response = await fetch(`${API_BASED_URL}api/facilities`, {
        headers: { Authorization: token }
      });
      const data = await response.json();
      if (response.ok) {
        // Filter out facilities where superuser_base_hours is 0 or null
        // Only show facilities that allow superuser access (base_hours > 0)
        const availableFacilities = data.filter(facility => 
          facility.superuser_base_hours && 
          facility.superuser_base_hours > 0
        );
        setFacilities(availableFacilities);
      } else {
        setError('Failed to load facilities');
      }
    } catch (err) {
      setError('Failed to load facilities');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFacility || !reason.trim()) {
      setError('Please select a facility and provide a reason');
      return;
    }

    console.log('Submitting superuser request with token:', token);
    console.log('Token length:', token ? token.length : 0);

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`${API_BASED_URL}api/superuser/request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify({
          facility_id: selectedFacility,
          reason: reason.trim()
        })
      });

      const data = await response.json();
      console.log('Response status:', response.status);
      console.log('Response data:', data);
      
      if (response.ok) {
        setSuccess(data.message);
        setTimeout(() => {
          onSuccess();
          onClose();
        }, 2000);
      } else {
        setError(data.message || 'Failed to submit request');
      }
    } catch (err) {
      setError('Failed to submit request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-900">Request Superuser Status</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl font-bold"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select Facility *
            </label>
            <select
              value={selectedFacility}
              onChange={(e) => setSelectedFacility(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              required
              disabled={facilities.length === 0}
            >
              <option value="">
                {facilities.length === 0 
                  ? "No facilities available for superuser registration" 
                  : "Choose a facility..."
                }
              </option>
              {facilities.map((facility) => (
                <option key={facility.id} value={facility.id}>
                  {facility.name}
                </option>
              ))}
            </select>
            {facilities.length === 0 && (
              <p className="text-sm text-gray-500 mt-1">
                No facilities are currently configured for superuser access. Contact the administrator if you need superuser privileges.
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Reason for Request *
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows="4"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Please explain why you need superuser access to this facility..."
              required
            />
          </div>

          {error && (
            <div className="text-red-600 text-sm bg-red-50 p-3 rounded-md">
              {error}
            </div>
          )}

          {success && (
            <div className="text-green-600 text-sm bg-green-50 p-3 rounded-md">
              {success}
            </div>
          )}

          <div className="flex space-x-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || facilities.length === 0}
              className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50"
            >
              {loading ? 'Submitting...' : 'Submit Request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SuperuserRegistration;
